export default __webpack_public_path__ + "static/media/vaccine-color.13e3d2d5.svg";